module.exports = "/_next/static/images/SubjectRightsManagement@2x-b7151d93c1c827e5c66333d2e0430028.png";